import { useMediaQuery } from './useMediaQuery';

export const useIsPwa = () => {
  const standalone = useMediaQuery('(display-mode: standalone)');
  const fullscreen = useMediaQuery('(display-mode: fullscreen)');
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;

  return standalone || iosStandalone || (fullscreen && !document.fullscreenElement);
};
